import * as XLSX from 'xlsx'

export const formatExportData = (
  bookings,
  activeSocietyId,
  activeSocietyName
) => {
  return bookings
    .filter(
      booking =>
        booking.payment_mode === 'Installment' &&
        booking.plot_id?.society_id === activeSocietyId
    )
    .map(booking => ({
      'Booking Number': booking.booking_number,
      'Customer Name': booking.customer_id?.name || 'Unknown',
      'Plot Number': booking.plot_id?.plot_number || 'N/A',
      'Total Paid Amount': booking.total_amount,
      'Receipt Number': booking.receipt_no,
      'Booking Date': (() => {
        try {
          if (!booking.booking_date) return 'N/A'
          const date = new Date(booking.booking_date)
          return isNaN(date.getTime()) ? 'N/A' : date.toLocaleDateString('en-PK')
        } catch {
          return 'N/A'
        }
      })(),
      'Payment Mode': booking.payment_mode,
      'Society Name':
        activeSocietyName ||
        booking.plot_id?.Society_id?.name ||
        booking.plot_id?.society_name ||
        'N/A',
      // Additional fields for comprehensive export
      'Customer Phone': booking.customer_id?.contactInfo?.phone || 'N/A',
      'Plot Size': booking.plot_id?.size || 'N/A',
      'Payment Status': booking.booking_status || 'N/A',
      'Remaining Balance': booking.remaining_balance || '0',
      'Installment Duration': (() => {
        const years = booking.installment_years
        if (!years || years === 0) return 'N/A'

        const totalMonths = Math.round(years * 12)
        const yearsPart = Math.floor(totalMonths / 12)
        const monthsPart = totalMonths % 12

        if (yearsPart === 0) {
          return `${monthsPart} Month${monthsPart !== 1 ? 's' : ''}`
        } else if (monthsPart === 0) {
          return `${yearsPart} Year${yearsPart !== 1 ? 's' : ''}`
        } else {
          return `${yearsPart} Year${
            yearsPart !== 1 ? 's' : ''
          } ${monthsPart} Month${monthsPart !== 1 ? 's' : ''}`
        }
      })()
    }))
}

export const exportToExcel = (
  data,
  activeSocietyName,
  filename = 'installment_payment_bookings_export'
) => {
  const worksheet = XLSX.utils.json_to_sheet(data)
  const workbook = XLSX.utils.book_new()

  // Truncate society name to max 31 characters
  const truncatedSocietyName = activeSocietyName
    ? activeSocietyName.substring(0, 28) + '...'
    : 'Installment Payments'

  XLSX.utils.book_append_sheet(workbook, worksheet, truncatedSocietyName)

  XLSX.writeFile(
    workbook,
    `${activeSocietyName || 'Bookings'}_installment_payment_bookings_${
      new Date().toISOString().split('T')[0]
    }.xlsx`
  )
}

export const filterBookingsByDateRange = (
  bookings,
  startDate,
  endDate,
  activeSocietyId
) => {
  return bookings.filter(booking => {
    if (!booking.booking_date) return false
    try {
      const bookingDate = new Date(booking.booking_date)
      if (isNaN(bookingDate.getTime())) return false
      return (
        bookingDate >= startDate &&
        bookingDate <= endDate &&
        booking.payment_mode === 'Installment' &&
        booking.plot_id?.society_id === activeSocietyId
      )
    } catch {
      return false
    }
  })
}

export const getDateRanges = () => {
  const now = new Date()
  return {
    today: {
      start: new Date(now.getFullYear(), now.getMonth(), now.getDate()),
      end: new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        23,
        59,
        59
      )
    },
    thisMonth: {
      start: new Date(now.getFullYear(), now.getMonth(), 1),
      end: new Date(now.getFullYear(), now.getMonth() + 1, 0)
    },
    lastMonth: {
      start: new Date(now.getFullYear(), now.getMonth() - 1, 1),
      end: new Date(now.getFullYear(), now.getMonth(), 0)
    },
    thisYear: {
      start: new Date(now.getFullYear(), 0, 1),
      end: new Date(now.getFullYear(), 11, 31)
    },
    lastYear: {
      start: new Date(now.getFullYear() - 1, 0, 1),
      end: new Date(now.getFullYear() - 1, 11, 31)
    }
  }
}
